import type { Theme } from "domains/theme/types";

export const setThemeColorMeta = (theme: Theme) => {
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const value = theme === "dark" ? "#000" : "#fff";
  if (themeColorMeta !== null && themeColorMeta.getAttribute("content") !== value)
    themeColorMeta.setAttribute("content", value);
};
